// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { NavigationInstruction, Next, PipelineStep, Redirect } from "aurelia-router";

@autoinject
export class ModuleRestoreStep implements PipelineStep {
    private previousWorkflowUris: Map<string, string>;
    //This is a temporary workaround since at implementation of the restore feature, not all workflows/modules update the URL correctly
    //This behavior is reported in Jira (https://sorama.atlassian.net/browse/SIS-6429 and https://sorama.atlassian.net/browse/SIS-6524)
    private supportedWorkflows: string[] = ["streaming", "analysis"];
    constructor() {
        this.previousWorkflowUris = new Map();
    }

    public getPreviousWorkflowUris(): Map<string, string> {
        return this.previousWorkflowUris;
    }

    public registerUriForWorkflow(workflow: string, uri: string): void {
        this.previousWorkflowUris.set(workflow.toLowerCase(), workflow + uri);
    }

    public run(instruction: NavigationInstruction, next: Next): Promise<unknown> {
        if (
            instruction.config &&
            instruction.config.name &&
            this.supportedWorkflows.includes(instruction.config.name)
        ) {
            let prevUri: string = this.previousWorkflowUris.get(instruction.config.name);

            if (prevUri) {
                // Check if we are navigating to a timeline entry. Last check prevents infinite redirect loop.
                if (
                    instruction.queryString &&
                    instruction.queryString.includes("[timeline]entryId=") &&
                    !prevUri.includes("[timeline]entryId=")
                ) {
                    // Check if prevUri already contains a query string
                    if (prevUri.includes("?")) {
                        prevUri += "&";
                    } else {
                        prevUri += "?";
                    }
                    prevUri += instruction.queryString;
                }

                this.previousWorkflowUris.delete(instruction.config.name);
                const redirect = new Redirect(prevUri);

                return next.cancel(redirect);
            }
        }

        return next();
    }
}
